/* eslint-disable @typescript-eslint/naming-convention */
// ValidationEngine 配置集中管理
// 用于替代临时的 getValidationConfig 方法

// Bar 系列
import { barValidationConfig } from './preset/bar/bar.processor';
import { bar3DValidationConfig } from './preset/bar/bar3D.processor';
import { barDistributionValidationConfig } from './preset/bar/barDistribution.processor';
import { chainChangeBarValidationConfig } from './preset/bar/chainChangeBar.processor';
import { contrastDoubleBarValidationConfig } from './preset/bar/contrastDoubleBar.processor';
import { dynamicRankingHorizontalBarValidationConfig } from './preset/bar/dynamicRankingHorizontalBar.processor';
import { dynamicRankingTwoWayHorizontalBarValidationConfig } from './preset/bar/dynamicRankingTwoWayHorizontalBar.processor';
import { groupedStackedBarValidationConfig } from './preset/bar/groupedStackedBar.processor';
import { polarBarValidationConfig } from './preset/bar/polarBar.processor';
import { positiveAndNegativeDoubleIndicatorSumBarValidationConfig } from './preset/bar/positiveAndNegativeDoubleIndicatorSumBar.processor';
import { rankingHorizontalBarValidationConfig } from './preset/bar/rankingHorizontalBar.processor';
import { rankingTwoWayHorizontalBarValidationConfig } from './preset/bar/rankingTwoWayHorizontalBar.processor';
import { shadowBarValidationConfig } from './preset/bar/shadowBar.processor';
import { stackBoardBarValidationConfig } from './preset/bar/stackBoardBar.processor';
import { waterfallValidationConfig } from './preset/bar/waterfall.processor';

// Line 系列
import { lineValidationConfig } from './preset/line/line.processor';
import { bandedIntervalTrendLineValidationConfig } from './preset/line/bandedIntervalTrendLine.processor';
import { dynamicLineValidationConfig } from './preset/line/dynamicLine.processor';
import { dynamicRankingLineValidationConfig } from './preset/line/dynamicRankingLine.processor';
import { markerLineValidationConfig } from './preset/line/markerLine.processor';
import { positiveAndNegativeDoubleIndicatorComparisonLineValidationConfig } from './preset/line/positiveAndNegativeDoubleIndicatorComparisonLine.processor';
import { rankingLineValidationConfig } from './preset/line/rankingLine.processor';

// Pie 系列
import { pieValidationConfig } from './preset/pie/pie.processor';
import { doublePieValidationConfig } from './preset/pie/doublePie.processor';
import { dynamicPieValidationConfig } from './preset/pie/dynamicPie.processor';

// Scatter 系列
import { scatterValidationConfig } from './preset/scatter/scatter.processor';
import { scatter3DValidationConfig } from './preset/scatter/scatter3D.processor';
import { dynamicBubbleValidationConfig } from './preset/scatter/dynamicBubble.processor';
import { dynamicBeeSwarmValidationConfig } from './preset/scatter/dynamicBeeSwarm.processor';

// Gauge 系列
import { gaugeValidationConfig } from './preset/gauge/gauge.processor';
import { multiIndicatorRingGaugeValidationConfig } from './preset/gauge/multiIndicatorRingGauge.processor';

// Funnel 系列
import { funnelValidationConfig } from './preset/funnel/funnel.processor';

// Radar 系列
import { radarValidationConfig } from './preset/radar/radar.processor';

// Tree 系列
import { treeValidationConfig } from './preset/tree/tree.processor';

// TreeMap 系列
import { treeMapValidationConfig } from './preset/treeMap/treeMap.processor';
import { dynamicTreeMapValidationConfig } from './preset/treeMap/dynamicTreeMap.processor';
import { drillableTreemapValidationConfig } from './preset/treeMap/drillableTreemap.processor';

// HxKLine 系列
import { hxKLineValidationConfig } from './preset/hxKLine/hxKLine.processor';
import { hxKLineAndBarValidationConfig } from './preset/hxKLine/hxKLineAndBar.processor';
import { hxKLineAndDynamicLineValidationConfig } from './preset/hxKLine/hxKLineAndDynamicLine.processor';
import { hxKLineAndMultiIndicatorLineValidationConfig } from './preset/hxKLine/hxKLineAndMultiIndicatorLine.processor';
import { hxKLineAndTagValidationConfig } from './preset/hxKLine/hxKLineAndTag.processor';

// Text 系列
import { textValidationConfig } from './preset/text/text.processor';
import { summaryTextValidationConfig } from './preset/text/summaryText.processor';
import { multiTableValidationConfig } from './preset/text/multiTable.processor';
import { timeLineValidationConfig } from './preset/text/timeLine.processor';

// Other 系列
import { dynamicSankeyValidationConfig } from './preset/other/dynamicSankey.processor';
import { dynamicVoronoiValidationConfig } from './preset/other/dynamicVoronoi.processor';
import { wordCloudValidationConfig } from './preset/other/wordCloud.processor';

import type { ValidationConfig, TabularData } from '../core/dataProcessor/types';

// 验证配置映射表
export const validationConfigs: Record<string, ValidationConfig> = {
  // Bar 系列
  bar: barValidationConfig,
  bar3D: bar3DValidationConfig,
  barDistribution: barDistributionValidationConfig,
  chainChangeBar: chainChangeBarValidationConfig,
  contrastDoubleBar: contrastDoubleBarValidationConfig,
  dynamicRankingHorizontalBar: dynamicRankingHorizontalBarValidationConfig,
  dynamicRankingTwoWayHorizontalBar: dynamicRankingTwoWayHorizontalBarValidationConfig,
  groupedStackedBar: groupedStackedBarValidationConfig,
  polarBar: polarBarValidationConfig,
  positiveAndNegativeDoubleIndicatorSumBar:
    positiveAndNegativeDoubleIndicatorSumBarValidationConfig,
  rankingHorizontalBar: rankingHorizontalBarValidationConfig,
  rankingTwoWayHorizontalBar: rankingTwoWayHorizontalBarValidationConfig,
  shadowBar: shadowBarValidationConfig,
  stackBoardBar: stackBoardBarValidationConfig,
  waterfall: waterfallValidationConfig,

  // Line 系列
  line: lineValidationConfig,
  bandedIntervalTrendLine: bandedIntervalTrendLineValidationConfig,
  dynamicLine: dynamicLineValidationConfig,
  dynamicRankingLine: dynamicRankingLineValidationConfig,
  markerLine: markerLineValidationConfig,
  positiveAndNegativeDoubleIndicatorComparisonLine:
    positiveAndNegativeDoubleIndicatorComparisonLineValidationConfig,
  rankingLine: rankingLineValidationConfig,

  // Pie 系列
  pie: pieValidationConfig,
  doublePie: doublePieValidationConfig,
  dynamicPie: dynamicPieValidationConfig,

  // Scatter 系列
  scatter: scatterValidationConfig,
  scatter3D: scatter3DValidationConfig,
  dynamicBubble: dynamicBubbleValidationConfig,
  dynamicBeeSwarm: dynamicBeeSwarmValidationConfig,

  // Gauge 系列
  gauge: gaugeValidationConfig,
  multiIndicatorRingGauge: multiIndicatorRingGaugeValidationConfig,

  // Funnel 系列
  funnel: funnelValidationConfig,

  // Radar 系列
  radar: radarValidationConfig,

  // Tree 系列
  tree: treeValidationConfig,

  // TreeMap 系列
  treeMap: treeMapValidationConfig,
  dynamicTreeMap: dynamicTreeMapValidationConfig,
  drillableTreemap: drillableTreemapValidationConfig,

  // HxKLine 系列
  hxKLine: hxKLineValidationConfig,
  hxKLineAndBar: hxKLineAndBarValidationConfig,
  hxKLineAndDynamicLine: hxKLineAndDynamicLineValidationConfig,
  hxKLineAndMultiIndicatorLine: hxKLineAndMultiIndicatorLineValidationConfig,
  hxKLineAndTag: hxKLineAndTagValidationConfig,

  // Text 系列
  text: textValidationConfig,
  summaryText: summaryTextValidationConfig,
  multiTable: multiTableValidationConfig,
  timeLine: timeLineValidationConfig,

  // Other 系列
  dynamicSankey: dynamicSankeyValidationConfig,
  dynamicVoronoi: dynamicVoronoiValidationConfig,
  wordCloud: wordCloudValidationConfig
};

// 默认验证配置（用于未配置的图层类型）
const defaultValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'sufficient-data',
      validator: (data: TabularData | Record<string, unknown> | object) =>
        Array.isArray(data) && data.length > 0,
      message: 'Chart requires at least 1 data point',
      suggestion: 'Provide data for chart visualization',
      severity: 'warning'
    }
  ]
};

/**
 * 获取指定图层类型的验证配置
 * @param layerType 图层类型
 * @returns 验证配置对象
 */
export function getValidationConfig(layerType: string): ValidationConfig {
  return validationConfigs[layerType] || defaultValidationConfig;
}
